export default {
  default: () => import("/home/debian/projects/my-website/layouts/default.vue").then(m => m.default || m),
  error: () => import("/home/debian/projects/my-website/layouts/error.vue").then(m => m.default || m)
}